function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 17,
  r: 17,
  fill: "#FFDC4A"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.32446 13.3044C9.32446 12.488 10.0881 11.8262 11.0301 11.8262H11.883C12.825 11.8262 13.5887 12.488 13.5887 13.3044V22.174C13.5887 22.9904 12.825 23.6523 11.883 23.6523H11.0301C10.0881 23.6523 9.32446 22.9904 9.32446 22.174V13.3044Z",
  fill: "#AD8D07"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M20.4114 13.3044C20.4114 12.488 21.1751 11.8262 22.1171 11.8262H22.9699C23.912 11.8262 24.6756 12.488 24.6756 13.3044V22.174C24.6756 22.9904 23.912 23.6523 22.9699 23.6523H22.1171C21.1751 23.6523 20.4114 22.9904 20.4114 22.174V13.3044Z",
  fill: "#AD8D07"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M22.9699 15.5218C22.9699 14.7054 23.7336 14.0436 24.6756 14.0436H25.5285C26.4705 14.0436 27.2342 14.7054 27.2342 15.5218V19.9566C27.2342 20.773 26.4705 21.4349 25.5285 21.4349H24.6756C23.7336 21.4349 22.9699 20.773 22.9699 19.9566V15.5218Z",
  fill: "#AD8D07"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M6.76593 15.5218C6.76593 14.7054 7.52959 14.0436 8.47161 14.0436H9.32446C10.2665 14.0436 11.0301 14.7054 11.0301 15.5218V19.9566C11.0301 20.773 10.2665 21.4349 9.32446 21.4349H8.47161C7.52959 21.4349 6.76593 20.773 6.76593 19.9566V15.5218Z",
  fill: "#AD8D07"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M5.91309 17.0001C5.91309 16.5919 6.29492 16.261 6.76593 16.261H10.1773C10.6483 16.261 11.0301 16.5919 11.0301 17.0001V18.4783C11.0301 18.8866 10.6483 19.2175 10.1773 19.2175H6.76593C6.29492 19.2175 5.91309 18.8866 5.91309 18.4783V17.0001Z",
  fill: "#AD8D07"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M22.9699 17.0001C22.9699 16.5919 23.3518 16.261 23.8228 16.261H27.2342C27.7052 16.261 28.087 16.5919 28.087 17.0001V18.4783C28.087 18.8866 27.7052 19.2175 27.2342 19.2175H23.8228C23.3518 19.2175 22.9699 18.8866 22.9699 18.4783V17.0001Z",
  fill: "#AD8D07"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M22.9699 16.261C23.912 16.261 24.6756 16.9228 24.6756 17.7392C24.6756 18.5556 23.912 19.2175 22.9699 19.2175L11.0301 19.2175C10.0881 19.2175 9.32446 18.5556 9.32446 17.7392C9.32446 16.9228 10.0881 16.261 11.0301 16.261H22.9699Z",
  fill: "#AD8D07"
});

function SvgPractice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34 34",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

var ForwardRef = React.forwardRef(SvgPractice);
export default __webpack_public_path__ + "static/media/practice.b7976a29.svg";
export { ForwardRef as ReactComponent };